/**
 * Maintains global PLP order with in-stock products first.
 * For paginated mode, this fetches every page, sorts globally, then renders
 * only the current page slice so sold-out products are pushed to final pages.
 */
(function () {
  function getDirectColumns(grid) {
    var nodes = [];
    var children = grid.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains('column')) {
        nodes.push(children[i]);
      }
    }
    return nodes;
  }

  function sortProductsByAvailability(items) {
    var inStock = [];
    var soldOut = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-product-available') === 'true') {
        inStock.push(items[i]);
      } else {
        soldOut.push(items[i]);
      }
    }
    return inStock.concat(soldOut);
  }

  function collectionGridMoveSoldOutToEnd(grid) {
    if (!grid) {
      return;
    }
    var sorted = sortProductsByAvailability(getDirectColumns(grid));
    for (var i = 0; i < sorted.length; i++) {
      grid.appendChild(sorted[i]);
    }
  }

  function buildPageUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  function parseProductsFromHtml(htmlText) {
    var parsed = new DOMParser().parseFromString(htmlText, 'text/html');
    var grid = parsed.getElementById('product-grid');
    if (!grid) {
      return [];
    }
    return getDirectColumns(grid);
  }

  function renderSlice(grid, items, start, end) {
    grid.innerHTML = '';
    for (var i = start; i < end && i < items.length; i++) {
      grid.appendChild(items[i]);
    }
  }

  function enforceGlobalPaginatedAvailabilityOrder(grid) {
    var totalPages = parseInt(grid.getAttribute('data-total-pages'), 10) || 1;
    var currentPage = parseInt(grid.getAttribute('data-current-page'), 10) || 1;
    var pageSize = parseInt(grid.getAttribute('data-products-per-page'), 10) || 24;
    var paginationType = grid.getAttribute('data-pagination-type');

    if (paginationType !== 'paginated' || totalPages <= 1) {
      collectionGridMoveSoldOutToEnd(grid);
      return;
    }

    if (grid.dataset.soldoutGlobalOrderingApplied === 'true') {
      return;
    }
    grid.dataset.soldoutGlobalOrderingApplied = 'true';

    var requests = [];
    for (var page = 1; page <= totalPages; page++) {
      requests.push(
        fetch(buildPageUrl(page))
          .then(function (response) {
            return response.text();
          })
          .then(function (htmlText) {
            return parseProductsFromHtml(htmlText);
          })
      );
    }

    Promise.all(requests)
      .then(function (pages) {
        var allProducts = [];
        for (var i = 0; i < pages.length; i++) {
          allProducts = allProducts.concat(pages[i]);
        }

        var sorted = sortProductsByAvailability(allProducts);
        var sliceStart = (currentPage - 1) * pageSize;
        var sliceEnd = sliceStart + pageSize;
        renderSlice(grid, sorted, sliceStart, sliceEnd);
      })
      .catch(function () {
        collectionGridMoveSoldOutToEnd(grid);
      });
  }

  window.collectionGridMoveSoldOutToEnd = collectionGridMoveSoldOutToEnd;
  window.collectionGridEnforceGlobalAvailabilityOrder = enforceGlobalPaginatedAvailabilityOrder;

  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('product-grid');
    if (grid) {
      enforceGlobalPaginatedAvailabilityOrder(grid);
    }
  });
})();
